import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FilterpopupComponent } from '../grid/filterpopup/filterpopup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
import { EmpfindComponent } from '../empfind/empfind.component';
@Component({
  selector: 'app-bonus',
  templateUrl: './bonus.component.html',
  styleUrls: ['./bonus.component.css']
})
export class BonusComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
    isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "Bonus";

  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterbonustypeid: any = null;
  filterbonustypename: any = null;
  filterpaymentstatus:string = "";
  bonusColl: any = [];

 
 

  searchtxt: any = "";
  columnDefs = [
    {
      headerName: 'Bonus Date', field: 'transdt', type:'date'
    },
    { headerName: 'Employee', field: 'empname' },
    { headerName: 'Bonus Type', field: 'bonustypename' },
    {
      headerName: 'Effective On', field: 'effectivedt', type:'month'
    },

    { headerName: 'Amount', field: 'amount',  type:'decimal' },
    { headerName: 'Payment Status', field: 'paymentstatus' },

    {
      headerName: 'Approval Status', field: 'approvedstatus',
      cellStyle: function (params) {
        var deptBO = params.data;
        if (deptBO.approvedstatus === 'Approved') {
          return { color: '#28a745' }
        }
        else if (deptBO.approvedstatus === 'Rejected') {
          return { color: '#dc3545' }
        }
        else if (deptBO.approvedstatus === 'Pending') {
          return { color: '#dda22f' }
        }
        else if (deptBO.approvedstatus === 'Pending(R)') {
          return { color: '#d254f2' }
        }       
        else {
          return '';
        }
      },
    },

  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
    pageindex : 1
  };

  sdate = new Date();
  rdate = new Date();



  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, private datePipe: DatePipe, private productFindService: NgbModal,) {
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.sdate=new Date(Date.UTC(this.rdate.getUTCFullYear(),this.rdate.getUTCMonth(),this.rdate.getUTCDate()));
    
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }
      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }
      if (params.fromdate !== undefined) {
        console.log(params.fromdate)
        console.log(this.fnConvertDatetime(params.fromdate))
        console.log(this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate)))
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        console.log(params.todate)
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.bonustypeid !== undefined) {
        this.filterbonustypeid = params.bonustypeid
      }
      if (params.bonustypename !== undefined) {
        this.filterbonustypename = params.bonustypename
      }
      if (params.paymentstatus !== undefined) {
        this.filterpaymentstatus = params.paymentstatus
      }
      
    })
  }
  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetBonus();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
 

  //Event  
  fnActionEditClick(data) {
   
    if (!this.isedit) {
      return;
    }
   
      this.fnEditForm(data.bonusid);
    }
    

  fnActionDeleteClick(data) {
    

    if (!this.isdelete) {
      return;
    }
    
      this.fnDeleteConfirm(data.bonusid, this.fngetDescriptionRefno(data));
    }
   

  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'bonuslist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };
   // this.gridApi.exportDataAsCsv(params);
  }

  fnActionFilterClick() {

    // this.filterbar.filterstatus = this.filterstatus;

    // this.isfilter = !this.isfilter;

    this.fnShowFilterPopup();
  }

  
  fnActionBulkUploadClick() {   
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'status': this.filterstatus,
          'empid': this.filteremployeeid,
          'empname': this.filteremployeename,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
          'bonustypeid': this.filterbonustypeid,
          'bonustypename': this.filterbonustypename,
          'paymentstatus': this.filterpaymentstatus,
        }
      }

      this.router.navigate(['/AddBulkBonus'], navigationExtras);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }


    

  }

  fnActionRefreshClick() {
    this.fngetBonus()
  }
  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetBonus();

  }
  fnApplyFilterPop(data) {
    //this.isfilter = !this.isfilter;

    this.filteremployeeid = data.empid;
    this.filteremployeename = data.empname;
    this.filterfromdate = data.fromdate;
    this.filtertodate = data.todate;
    this.filterbonustypeid = data.bonustypeid;
    this.filterbonustypename = data.bonustypename;
    this.filterpaymentstatus = data.paymentstatus;
    this.fngetBonus();

  }
  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    if (this.filteremployeeid > 0) {
      queryParams['empid'] = this.filteremployeeid;
    }
    if (this.filteremployeename != '') {
      queryParams['empname'] = this.filteremployeename;
    }
    if (this.filterfromdate != '') {
      queryParams['fromdate'] = this.fnFormatDatetime(this.filterfromdate);
    }
    if (this.filtertodate != '') {
      queryParams['todate'] = this.fnFormatDatetime(this.filtertodate);
    }
    if (this.filterbonustypeid > 0) {
      queryParams['bonustypeid'] = this.filterbonustypeid;
    }
    if (this.filterbonustypename != '') {
      queryParams['bonustypename'] = this.filterbonustypename;
    }
    if (this.filterpaymentstatus != '') {
      queryParams['paymentstatus'] = this.filterpaymentstatus;
    }
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetBonus();
    }
    else {
      this.filterstatus = "";
      this.fngetBonus();
    }
  }
  //Get
  fngetBonus() {
    if (this.showProgress) {
      return;
    }
    this.fnCurrentRouteChange();
    this.fnShowProgress();
    var data = {
      'bonusid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': this.filterstatus,
      'empid': this.filteremployeeid,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'bonustypeid': this.filterbonustypeid,
      'paymentstatus': this.filterpaymentstatus,
    }
    this.appService.getBonusListview(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.bonusColl = res.json().result;
            console.log(res.json().result)
            this.fnCurrentRouteChange();

            this.fnSetTable();


          } else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnAddForm() {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'status': this.filterstatus,
          'empid': this.filteremployeeid,
          'empname': this.filteremployeename,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
          'bonustypeid': this.filterbonustypeid,
          'bonustypename': this.filterbonustypename,
          'paymentstatus': this.filterpaymentstatus,
        }
      }

      this.router.navigate(['/AddBonus'], navigationExtras);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }


  }

  fnEditForm(deptid) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
          'status': this.filterstatus,
          'empid': this.filteremployeeid,
          'empname': this.filteremployeename,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
          'bonustypeid': this.filterbonustypeid,
          'bonustypename': this.filterbonustypename,
          'paymentstatus': this.filterpaymentstatus,
        }
      }

      this.router.navigate(['/AddBonus'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }


  }


  public fnDeleteConfirm(deptid, reftxt) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete bonus?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteForm(deptid, reftxt)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteForm(deptid, reftxt) {
    var data = {
      'bonusid': deptid,
    }
    this.appService.fnDeleteBonus(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The bonus has been deleted successfully.");
            this.fnInsertActivityLog('DELETE', deptid, reftxt);

            this.fngetBonus();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnSetTable() {
   
  }
  fnResetGrid(data) {
    this.searchtxt = data;
    this.gridOptions.pageindex = 1
  }

  public fnSearchDatatable(value) {
   
  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.bonusColl[index].hoverfocus = "IN"
      }
      else {
        this.bonusColl[index].hoverfocus = ""
      }
    }
  }
  fnShowFilterPopup() {

    const modalRef = this.productFindService.open(FilterpopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.employeeid = !this.filteremployeeid ? null :Number(this.filteremployeeid);
    modalRef.componentInstance.fromdate = this.filterfromdate;
    modalRef.componentInstance.todate = this.filtertodate;
    modalRef.componentInstance.bonustypeid =!this.filterbonustypeid ? null :Number(this.filterbonustypeid);
    modalRef.componentInstance.paymentstatus = this.filterpaymentstatus;
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

     

      if (receivedEntry.status === 'DONE') {
        this.filteremployeeid = receivedEntry.employeeid;
        this.filteremployeename = receivedEntry.empname;
        this.filterfromdate = receivedEntry.fromdate;
        this.filtertodate = receivedEntry.todate;
        this.filterbonustypeid = receivedEntry.bonustypeid;
        this.filterbonustypename = receivedEntry.bonustypename;
        this.filterpaymentstatus = receivedEntry.paymentstatus;
       
        this.fngetBonus();
      }


    });
  }
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.bonusColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  } 
  fnFormatDecimal(params) {
    if (params.value) {
      return params.value.toFixed(2)
    }
  }

  fnMomentMonthFormatter(params) {
    if (params.value) {
      return moment(params.value).format('MMM-YYYY');//  
    }
    else {
      return '';
    }

  }

  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }
  }
  
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  

  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}

